import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import "./theme.css";
import "./Header.css";
import logo from "./logo.png";

const NAV_LINKS = [
  { to: "/courses", label: "Courses" },
  { to: "/trainers", label: "Trainers" },
  { to: "/institutions", label: "Institutes" },
  { to: "/internships", label: "Internships" },
  { to: "/jobs", label: "Jobs" },
  { to: "/employers", label: "Employers" },
  { to: "/contact", label: "Contact Us" },
];

/** Singular detail routes that should keep the listing nav item highlighted */
const NAV_DETAIL_PREFIXES = {
  "/trainers": ["/trainer/"],
  "/institutions": ["/institution/"],
  "/employers": ["/employer/"],
};

export default function Header() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const closeSidebar = () => setSidebarOpen(false);
  const isActive = (path) => {
    if (
      location.pathname === path ||
      location.pathname.startsWith(`${path}/`)
    ) {
      return true;
    }
    return (NAV_DETAIL_PREFIXES[path] || []).some((prefix) =>
      location.pathname.startsWith(prefix)
    );
  };
  const showSignIn =
    !isActive("/courses") &&
    !isActive("/internships") &&
    !isActive("/jobs") &&
    !isActive("/contact");
  const signInPath =
    location.pathname === "/trainers" ||
    location.pathname.startsWith("/trainer")
      ? "/trainer-signin"
      : location.pathname === "/institutions" ||
          location.pathname.startsWith("/institution")
        ? "/institution-signin"
        : location.pathname === "/employers" ||
            location.pathname.startsWith("/employer") ||
            location.pathname.startsWith("/company")
          ? "/employer-signin"
          : "/trainee-signin";

  return (
    <header className="als-header">
      <div className="als-header-inner">
        <Link to="/" className="als-brand" onClick={closeSidebar}>
          <img src={logo} alt="Open Learnings" className="als-brand-logo" />
          <span className="als-brand-text">Open Learnings</span>
        </Link>

        <div className="als-header-right d-none d-xl-flex">
          <nav className="als-nav">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`als-nav-link ${isActive(link.to) ? "active" : ""}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          {showSignIn && (
            <Link to={signInPath} className="als-header-signin">
              Sign In
            </Link>
          )}
        </div>

        <button
          type="button"
          className="als-mobile-toggle d-xl-none"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
        >
          <FiMenu size={24} />
        </button>
      </div>

      <div className={`als-mobile-drawer ${isSidebarOpen ? "open" : ""}`}>
        <div className="als-mobile-drawer-head">
          <Link to="/" className="als-brand" onClick={closeSidebar}>
            <img src={logo} alt="Open Learnings" className="als-brand-logo" />
            <span className="als-brand-text">Open Learnings</span>
          </Link>
          <button type="button" onClick={closeSidebar} aria-label="Close menu">
            <FiX size={24} />
          </button>
        </div>
        <nav className="als-mobile-nav">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={closeSidebar}
              className={isActive(link.to) ? "active" : ""}
            >
              {link.label}
            </Link>
          ))}
          {showSignIn && (
            <div className="als-mobile-auth">
              <Link
                to={signInPath}
                className="als-header-signin"
                onClick={closeSidebar}
              >
                Sign In
              </Link>
            </div>
          )}
        </nav>
      </div>
      {isSidebarOpen && (
        <div className="als-mobile-backdrop" onClick={closeSidebar} />
      )}
    </header>
  );
}
